export default __webpack_public_path__ + "static/media/step-one.70c72c0c.png";